import React from 'react';
import { FlyerA6 } from '../components/FlyerA6';
export function FlyerA6Page() {
  return <FlyerA6 data-id="element-798" />;
}